import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutesEnum } from '@shared/types';
import { ButtonComponent } from '@ui-kit/buttons';

@Component({
    selector: 'app-error-page',
    standalone: true,
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    imports: [TranslateModule, ButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
    private router = inject(Router);
    private auth0 = inject(AuthService);

    private readonly urls = AppRoutesEnum;

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }

    goToDashboard(): void {
        if (this.router.url.toLowerCase().includes(this.urls.BASE)) {
            this.router.navigate([AppRoutesEnum.BASE]).then(() => {
                window.location.reload();
            });
        } else {
            this.router.navigate([AppRoutesEnum.BASE]);
        }
    }
}
